import React from 'react';
import { DominionLogo } from '../components/DominionLogo';
import { Button } from '../components/ui/button';

export default function NotFound() {
  const handleGoHome = () => {
    window.history.pushState({}, '', '/');
    window.dispatchEvent(new PopStateEvent('popstate'));
  };

  return (
    <div className="min-h-screen bg-[#0d0d12] relative overflow-hidden">
      {/* Background decorative elements */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 right-0 w-1/2 h-1/2 bg-gradient-to-bl from-[#90d977]/20 to-transparent blur-3xl" />
        <div className="absolute bottom-0 left-0 w-1/2 h-1/2 bg-gradient-to-tr from-[#90d977]/10 to-transparent blur-3xl" />
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 py-8 md:py-12 max-w-4xl">
        {/* Header */}
        <div className="flex justify-center items-center mb-8 md:mb-12">
          <DominionLogo className="h-6 md:h-8 w-auto" />
        </div>

        {/* 404 Content */}
        <div className="bg-[#1a1b25] border border-[#27272a] rounded-lg p-8 md:p-12 text-center">
          <h1 className="text-6xl md:text-8xl font-bold text-[#90d977] mb-4">404</h1>
          <h2 className="text-2xl md:text-3xl font-medium text-white mb-4">
            Page Not Found
          </h2>
          <p className="text-[#a1a1aa] mb-8">
            The page you're looking for doesn't exist or has been moved.
          </p>
          <Button
            onClick={handleGoHome}
            className="bg-[#90d977] hover:bg-[#7bc65f] text-black font-medium px-6"
          >
            Go Home
          </Button>
        </div>
      </div>
    </div>
  );
}